// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes slide{0%{background-position:200% 0%}100%{background-position:0% 0%}}.gf-border-wrapper{display:inline-flex}.gf-border-wrapper.animate{background-size:200% 100% !important;animation:slide 3s linear infinite}", ""]);
// Exports
module.exports = exports;
